import React from 'react';
import { Facebook, Instagram, MessageCircle, Heart } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-brand-dark text-stone-300 py-16 px-6" data-id="element-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left" data-id="element-9">
        <div className="space-y-4" data-id="element-10">
          <h3 className="text-2xl font-serif text-white mb-6" data-id="element-11">
            Dulce Despertar PUQ
          </h3>
          <p className="text-stone-400 max-w-xs mx-auto md:mx-0" data-id="element-12">
            Desayunos a domicilio para momentos especiales. Haciendo tus mañanas
            más dulces en Punta Arenas.
          </p>
        </div>

        <div className="space-y-4" data-id="element-13">
          <h4 className="text-lg font-serif text-white mb-6" data-id="element-14">Contacto</h4>
          <ul className="space-y-3" data-id="element-15">
            <li data-id="element-16">
              <a href="https://wa.me/56941832127?text=Hola!%20Me%20gustar%C3%ADa%20hacer%20un%20pedido%20%F0%9F%92%90" target="_blank" rel="noopener noreferrer" className="hover:text-brand-rose transition-colors inline-flex items-center" data-id="element-17">
                <MessageCircle className="w-4 h-4 mr-2" data-id="element-18" /> +569 4183 2127
              </a>
            </li>
            <li className="flex items-center justify-center md:justify-start text-stone-400" data-id="element-19">
              Punta Arenas, Chile
            </li>
          </ul>
        </div>

        <div className="space-y-4" data-id="element-20">
          <h4 className="text-lg font-serif text-white mb-6" data-id="element-21">Redes Sociales</h4>
          <div className="flex justify-center md:justify-start space-x-4" data-id="element-22">
            <a href="https://instagram.com/dulce.despertarpuq" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center hover:bg-brand-rose hover:text-white transition-all duration-300" data-id="element-23">
              <Instagram className="w-5 h-5" data-id="element-24" />
            </a>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-16 pt-8 border-t border-stone-800 text-center text-sm text-stone-500 flex flex-col md:flex-row items-center justify-between" data-id="element-25">
        <p data-id="element-26">
          &copy; {currentYear} Dulce Despertar PUQ. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 md:mt-0 flex items-center" data-id="element-27">
          Hecho con <Heart className="w-3 h-3 mx-1 text-brand-rose" data-id="element-28" /> en Punta
          Arenas
        </p>
      </div>
    </footer>;
}